import React, { useState } from 'react';
import {Button, Form, Modal, ConfigProvider, notification, Col, Input} from 'antd';
import Axios from "../../config/axiosConfig/axios";
import {Api} from "../../config/apiList/api";



const AddValidityToAmlak = ({ open, onCreate, onCancel , id}) => {
    const [form] = Form.useForm();
    return (
        <ConfigProvider direction="rtl">
            <Modal
                style={{fontFamily: "iranSansBold"}}
                bodyStyle={{height: 100}}
                // style={{fontFamily: "iranSansBold"}}
                width={400}
                open={open}
                title="افزایش اعتبار املاک"
                okText="تایید"
                cancelText="انصراف"
                onCancel={onCancel}
                closable={false}
                onOk={() => {
                    form
                        .validateFields()
                        .then((values) => {
                            form.resetFields();
                            onCreate(values);
                        })
                        .catch((info) => {
                        });
                }}
            >


                <Form
                    form={form}
                    layout="vertical"
                    name="form_in_modal"
                    initialValues={{
                        modifier: 'public',
                    }}
                >

                        <Col xl={24} xs={24} xxl={24} >
                            <Form.Item name="days" label={<p style={{fontFamily: "iranSansBold"}}>تعداد روز</p>} requiredMark={"optional"}
                                       rules={[
                                           {
                                               required: true,
                                               message: 'لطفا برای تعداد روز مقداری وارد کنید!',
                                           },
                                       ]}>

                                <Input style={{borderRadius: "10px"}} type={"number"}/>
                            </Form.Item >
                        </Col>


                </Form>
            </Modal>
        </ConfigProvider>
    );
};

const EditModal = (props) => {
    const [open, setOpen] = useState(false);
    const RedNotification = (text) => {
        notification.open({
            message: "اخطار",
            description: text,
            style: {
                background: "#F3585c",
                color: "white",
                fontFamily: "IRANSansMobileFaNum",
                borderRadius: "5px",
            }
        })
    }
    const onCreate = async (values) => {

        const data = {
            days: values.days,
            codeAmlak: props.codeAmlak
        }


        await Axios.patch(`${Api}add-validity-to-amlak-panel`, data
        )
            .then(async (data) => {
                if (data.statusCode === 200 || data.statusCode === 201) {
                    await notification.open({
                        message: "موفقیت",
                        description: "درخواست با موفقیت انجام شد!",
                        style: {
                            background: "#43a047",
                            color: "white",
                            fontFamily: "IRANSansMobileFaNum",
                            borderRadius: "5px",
                        }
                    })

                }
                else {
                    RedNotification(data.message);
                }

            })
            .catch((error) => {
            });

        await Axios.get(`${Api}amlak-list-panel?page=${props.pageNumber}`
        )
            .then((data) => {
                if (data.statusCode === 200 || data.statusCode === 201) {
                    props.setAmlakList(data.data.data);
                }

            })
            .catch((error) => {
            });

        // // console.log('Received values of form: ', values);
        await setOpen(false);
    };
    return (
        <div >
            <Button
                type="primary"
                onClick={() => {
                    setOpen(true);
                }}
            >
              افزایش اعتبار

            </Button>

            <AddValidityToAmlak

                open={open}
                onCreate={onCreate}
                onCancel={() => {
                    setOpen(false);
                }}

            />
        </div>
    );
};
export default EditModal;